import { VZButton } from 'components/Button';
import styled from 'styled-components';
import { css, rem, screenMobilePlusAndBigger } from 'theme';

import { type StatusType, statusStyleMap } from './support-case-status-map';

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
  margin-top: ${rem(24)};
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: ${rem(16)};
  gap: ${rem(8)};

  ${screenMobilePlusAndBigger(css`
    flex-direction: row;
    margin-bottom: ${rem(8)};
  `)}
`;

export const CaseTitle = styled.h3`
  font-size: ${rem(18)};
  line-height: ${rem(24)};
`;

export const DetailsButton = styled(VZButton)`
  padding: 0;
  align-items: baseline;

  &:hover {
    text-decoration: underline;
  }

  svg {
    rotate: -90deg;
    width: ${rem(12)};
    height: ${rem(12)};
  }
`;

export const StatusBadge = styled.span<{ status: StatusType }>`
  display: flex;
  gap: ${rem(6)};
  align-items: center;
  padding: ${rem(4)} ${rem(12)};
  border-radius: ${rem(12)};
  font-size: ${rem(14)};
  font-weight: 500;
  white-space: nowrap;

  background-color: ${({ status }) => statusStyleMap[status]?.bg ?? 'var(--ref-color-gray-20)'};

  color: ${({ status }) => statusStyleMap[status]?.text ?? 'var(--ref-color-gray-80)'};

  svg {
    fill: ${({ status }) => statusStyleMap[status]?.icon ?? 'var(--ref-color-gray-80)'};
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${rem(16)};
`;

export const InfoRow = styled.div`
  display: flex;
  gap: ${rem(8)};
`;

export const NoContent = styled.p`
  text-align: center;
  padding: ${rem(32)};
  font-size: ${rem(16)};
`;
